// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
    // apiKey: "AIzaSyAC_A9KdFIgTtCBbdWFYj8Y3a0CNZBs0EM",
    // authDomain: "nooraffalite.firebaseapp.com",
    // projectId: "nooraffalite",
    // storageBucket: "nooraffalite.appspot.com",
    // messagingSenderId: "1089260295627",
    // appId: "1:1089260295627:web:a77860b970ebc65394124e"
    apiKey: "AIzaSyCuyr3yq4S51pd4V7yT6dpelB1-Kcxa7hw",
  authDomain: "flowingoffers-ebe0a.firebaseapp.com",
  databaseURL: "https://flowingoffers-ebe0a-default-rtdb.firebaseio.com",
  projectId: "flowingoffers-ebe0a",
  storageBucket: "flowingoffers-ebe0a.firebasestorage.app",
  messagingSenderId: "447901383654",
  appId: "1:447901383654:web:cd73f080e5bda901f23427"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage


export { db, auth, storage };

